import { render, staticRenderFns } from "./FornecedorRestricaoSelectModal.vue?vue&type=template&id=8ff6448a&scoped=true"
import script from "./FornecedorRestricaoSelectModal.vue?vue&type=script&lang=js"
export * from "./FornecedorRestricaoSelectModal.vue?vue&type=script&lang=js"
import style0 from "./FornecedorRestricaoSelectModal.vue?vue&type=style&index=0&id=8ff6448a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff6448a",
  null
  
)

export default component.exports